/**
 * @deprecated Este archivo está deprecado. Utilizar nueva estructura:
 * - Para configuración de dayjs: import { dayjs } from '@/core/config'
 * - Para utilidades de fecha: import { formatToLocalTime, parseDateDayjs } from '@/shared/common'
 * 
 * Ejemplo:
 * 
 * ANTES:
 * import dayjs, { formatToLocalTime } from '@/lib/dayjs'
 * 
 * AHORA:
 * import { dayjs } from '@/core/config'
 * import { formatToLocalTime } from '@/shared/common'
 */

import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsDuration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import 'dayjs/locale/es';

dayjs.locale('es');
dayjs.extend(customParseFormat);
dayjs.extend(dayjsDuration);
dayjs.extend(utc);
dayjs.extend(timezone);


/**
 * @deprecated  Utilizar parseDateDayjs desde '@/shared/common'.
 */
export const parseDateDayjs = (date: string): dayjs.Dayjs | null => {
  const patterns = [
    { regex: /^\d{2}-\d{2}-\d{4}$/, format: 'DD-MM-YYYY' },
    { regex: /^\d{2}\/\d{2}\/\d{4}$/, format: 'DD/MM/YYYY' },
  ];

  for (const pattern of patterns) {
    if (pattern.regex.test(date)) {
      const parsedDate = dayjs(date, pattern.format, true);
      if (parsedDate.isValid()) {
        return parsedDate;
      }
    }
  }

  return null;
};

/**
 * @deprecated  Utilizar 'dayjs' desde '@/core/config'.
 */
export default dayjs;